import React from "react";
import "./EnterpriseInfo.scss";
import { Flex } from "antd-mobile";
import http from "../../util/api.js";
import GoBack from "../../components/GoBack";

class EnterpriseInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentWillMount() {
    this.onSearch();
  }

  componentDidMount() {
    window.V5CHAT("hideBtn");
  }

  onSearch = async () => {
    let res;
    try {
      res = await http().getPublicTable({
        resid: 617190452853
      });
      this.setState({ data: res.data.data });
      // if(res.ErrorMsg === ""){
      // }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    let { data } = this.state;
    let showInfo = null;

    // 如果data的长度大于零，showInfo赋值界面
    if (data.length > 0) {
      showInfo = (
        <div>
          <div className="cropInfo_img">
            {/* <img
                        style={{width:'120px',height:'100%'}}
                        // scr={data[0].img} 
                        alt='' 
                        src="../../../public/assets/images/cropLogo.png"
                        /> */}
            <img
              style={{ width: "100%", height: "100%" }}
              src="/assets/images/cropLogo.png"
              alt=""
            />
          </div>
          <div className="cropInfo_msg">
            <div className="cropInfo_msg1">
              <p className="cropInfo_msg1_info">
                <span className="cropInfo_msg1_info1">菲尼萨</span>
                <span className="cropInfo_msg1_info2">Finisar Corporation</span>
              </p>
            </div>
            <div className="cropInfo_msg2">
              <span className="cropInfo_msg1_info">
                技术创新者|全面的产品组合|值得信赖的合作伙伴
              </span>
            </div>
            <div className="cropInfo_msg3">
              {/* <span className="cropInfo_msg3_info">
                        </span> */}
              {data[0].corpIntro}
            </div>
            <div className="cropInfo_msg4">
              <div className="cropInfo_msg4_info">
                <p className="cropInfo_msg4_info_p1">
                  <span style={{ fontWeight: "bold" }}>地址：</span>
                  <span>{data[0].address}</span>
                </p>
                <p className="cropInfo_msg4_info_p1">
                  <span style={{ fontWeight: "bold" }}>公交：</span>
                  <span>{data[0].transit}</span>
                </p>
                <p className="cropInfo_msg4_info_p1">
                  <span style={{ fontWeight: "bold" }}>电话：</span>
                  <span>{data[0].phone}</span>
                </p>
              </div>
            </div>
            <div className="cropInfo_msg5">
              <p className="cropInfo_msg5_info">班车时间：</p>
            </div>
            <div className="cropInfo_msg6">
              <p className="cropInfo_msg5_info">班车接泊地点：</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="cropInfo">
        <GoBack
          goBack={() => {
            this.props.history.goBack();
          }}
        />
        {showInfo}
      </div>
    );
  }
}

export default EnterpriseInfo;
